<div
  hlmCollapsible
  class="panel"
  [expanded]="_expanded()"
  [disabled]="disabled()"
  [class.panel--disabled]="disabled()"
  (expandedChange)="onExpandedChange($event)"
>
  <div class="panel__header">
    <button hlmCollapsibleTrigger type="button" size="lg" class="panel__trigger">
      <ocp-themed-icon
        name="chevron-down.svg"
        class="panel__chevron"
        [class.panel__chevron--expanded]="_expanded()"
        [size]="12"
      />
      {{ header() }}
    </button>
    <ng-content select="[panelActions]" />
  </div>
  <div hlmCollapsibleContent class="panel__content">
    <ng-content />
  </div>
</div>
